// extracted by mini-css-extract-plugin
export default {"delivery":"Delivery_delivery__-sodT","delivery_description":"Delivery_delivery_description__uCpoO","delivery_show":"Delivery_delivery_show__EifE9"};